import kemtai from './kemtai/locales';
import mixpanel from './mixpanel/locales';

export default {
  en: {
    ...kemtai.en,
    ...mixpanel.en,
  },
  es: {
    ...kemtai.es,
  },
  de: {
    ...kemtai.de,
  },
  cs: {
    ...kemtai.cs,
  },
  ja: {
    ...kemtai.ja,
  },
  sk: {
    ...kemtai.sk,
  },
};
